<template>
  <div class="pa-0">
    <div class="py-4 px-6 ma-2 layout-column elevation-3" v-bind:style="{'background-color': compColor.context.background}" style="border-radius:3px;">
      <div class="font-weight-regular subtitle-2 my-2" style="line-height: 1.2rem;text-align: justify;" v-bind:class="[compColor.widget.text]">
        Bitte sagen Sie uns, wenn etwas nicht so funktioniert, wie Sie es sich vorstellen. Sagen Sie uns auch, wenn Sie weitere Ideen haben, von denen Sie und Ihre KollegInnen profitieren könnten.
        Dasselbe gilt, wenn Sie Fragen zum Krebsregister, Probleme bei der Übertragung Ihrer Daten oder auch hier Verbesserungsvorschläge haben.
      </div>

      <v-btn :dark="compColor.isInDarkMode"
             @click="showFeedbackDialog=true"
             class="font-weight-regular subtitle-2 white--text text-none py-2 my-4 flex"
             :color="compColor.primeColor"
             dense
             depressed>
        {{ $t('COMPONENT_DASHBOARD.FEEDBACK_VIA_MAIL') }}
      </v-btn>
    </div>

    <!-- feedback dialog -->

    <v-dialog
      persistent
      v-model="showFeedbackDialog"
      max-width="750"
      @keydown.esc="showFeedbackDialog=false"
      overlay-opacity="0.9"
      :dark="compColor.isInDarkMode"
      :color="compColor.primeColor"
    >
      <div class="elevation-10 layout-column" style="border-radius: 6px;"
           v-bind:style="{background: compColor.contentFrame}">

        <!-- HEADER -->

        <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
             :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
          {{ $t('COMPONENT_DASHBOARD.FEEDBACK_TITLE') }}
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- CONTENT  -->

        <div class="ma-1 px-3 pt-5 pb-3 layout-column elevation-3" style="border-radius: 5px;position: relative;" :style="{'background': compColor.lxExpansion.background}">
          <div class="layout-row">
            <long-input
              class="flex"
              rows="5"
              inputType="textArea"
              :color="compColor.textInput"
              :label="$t('COMPONENT_DASHBOARD.FEEDBACK_TEXT')"
              v-model="feedbackText"
              :dense="denseFields"
              hide-details
            ></long-input>
          </div>

          <div class="layout-row">
            <v-switch
              v-model="userCopy"
              class="ml-4 mt-2 my-0 py-0"
              dense
              inset
              true-value="private"
              :color="compColor.prime"
              :dark="isDarkMode"
              hide-details
            >
              <template #label>
                <span class="body-2 blue-grey--text text--lighten-2">{{ $t('COMPONENT_DASHBOARD.USER_COPY') }}</span>
              </template>
            </v-switch>
          </div>
        </div>

        <!-- ACTIONS -->

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <div class="layout-row layout-align-end-center pa-1">
          <v-btn depressed :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1" @click="sendFeedback()">
            {{ $t('COMPONENT_DASHBOARD.SEND_FEEDBACK') }}
          </v-btn>
          <v-btn depressed :color="'grey'" :dark="isDarkMode" class="white--text text-none" @click="showFeedbackDialog=false">
            {{ $t('buttons.cancel.value') }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Feedback',
  data () {
    return {
      isLoading: false,
      showFeedbackDialog: false,
      feedbackText: null,
      userCopy: true
    }
  },
  methods: {
    sendFeedback () {
      if (this.isLoading) return
      this.isLoading = true

      this.$http.post('/dashboard/feedback', { feedbackText: this.feedbackText, userCopy: this.userCopy })
        .then(() => {
          this.feedbackText = null
          this.userCopy = true
          this.showFeedbackDialog = false
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
